module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEvSURBVHgBrVULzcJADC4ouN/BOfjBwXAwCXPAHAAKmAQcgINJABQcDsDB0YY2lHJ32xK+pFmuj6/PAEAGMUaH0qIcUUJ848y6BqaAAlDucRhhFDk67eN0bH5NKNjnWragEdAMwzjeWFtSG0hvr+yHEaQU40pV1iapV7aeYw7ZuPg6kSFSJ9UYvSU+zdlWJfa2zryvRn8z73/JVprRltsV0PK8GkmwQTMhhem4oHgUZw3zRAsPlB3KCuVvhsDvkvW65Qd8ty7JPhZF34/MqsU7j8LaHV+CjOEkhpYVvU1LV5C6hoSfkDY6m/yAtMZZbrgqEK5lsZAJJvLFWFLyVYtvUg6dIm6HSLlC6XALhVY6lTmoJVZs97yDXvl1MASzzRKoyhqmgMnt34lUTzaXinsC2F5fHH3eBY4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-btn.png
// module id = mJhh
// module chunks = 0